export default __webpack_public_path__ + "static/media/pie.4d841935.png";